// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * PaymentPage.css — Responsive overrides for src/pages/PaymentPage.jsx
 * Loads AFTER index.css. Uses .payment-page prefix (one extra class) to win
 * over the inline \\3c style> block that React injects after the webpack bundle.
 *
 * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px
 *
 * This is a PUBLIC checkout page — no sidebar, no nav. The single-column
 * card layout is already correct for desktop. These overrides make it
 * app-like on phones: full-bleed card, bigger QR, 44px touch targets.
 */

/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */
@media (max-width: 991px) {
  .payment-page {
    padding: 0.75rem;
  }

  .payment-page .payment-container {
    max-width: 520px;
  }
}

/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  /* ── Full-bleed page: no gap on small screens ── */
  .payment-page {
    padding: 0;
    /* Respect notched-device safe areas */
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
    align-items: flex-start;
    /* Prevent horizontal overflow from any overflow source */
    overflow-x: hidden;
  }

  /* ── Container: full-width, full-height ── */
  .payment-page .payment-container {
    max-width: 100%;
    max-height: none;
    min-height: 100vh;
    min-height: 100dvh;
  }

  /* ── Card: fills the screen, no floating chrome ── */
  .payment-page .payment-card {
    border-radius: 0;
    box-shadow: none;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 0;
    max-height: none;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);
    border-radius: 24px;
  }

  .payment-page .payment-card.expanded {
    padding: 0;
    max-height: none;
  }

  /* ── Header: tighten logo area ── */
  .payment-page .payment-header {
    margin-bottom: 0.625rem;
  }

  .payment-page .payment-logo img {
    max-width: 140px;
  }

  /* ── Amount: scale down slightly on narrow screens ── */
  .payment-page .payment-amount {
    font-size: clamp(1.75rem, 8vw, 2.5rem);
  }

  /* ── Partial payment banner: stack the progress values ── */
  .payment-page .partial-progress {
    flex-direction: column;
    gap: 0.125rem;
  }

  /* ── Form selects: full-height tap target; font-size 1rem prevents iOS zoom ── */
  .payment-page .form-group select {
    min-height: 44px;
    font-size: 1rem;
    padding: 0.625rem 2.5rem 0.625rem 0.875rem;
  }

  /* ── Primary pay button: full-width, 52px tall ── */
  .payment-page .pay-now-btn {
    min-height: 52px;
    font-size: 1.05rem;
    border-radius: 12px;
  }

  /* ── Session info: wrap instead of side-by-side ── */
  .payment-page .selected-info {
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: flex-start;
  }

  .payment-page .info-item {
    font-size: 0.875rem;
  }

  /* ── Tabs: 44px touch targets ── */
  .payment-page .tab-btn {
    min-height: 44px;
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  /* ── QR code: larger for legibility on phones ── */
  .payment-page .qr-code-box {
    width: 200px;
    height: 200px;
  }

  /* ── Address box: wrap text on tiny screens ── */
  .payment-page .address-text {
    font-size: 0.625rem;
    word-break: break-all;
  }

  /* ── Copy button: 44px tap target ── */
  .payment-page .copy-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem;
    flex-shrink: 0;
  }

  /* ── Wallet tab ── */
  .payment-page .connect-wallet-btn {
    min-height: 52px;
    font-size: 1rem;
  }

  /* ── Change-selection: 44px touch target ── */
  .payment-page .change-btn {
    min-height: 44px;
    font-size: 0.9rem;
    margin-top: 0.625rem;
  }

  /* ── Status/error cards: reduce giant padding ── */
  .payment-page .payment-status-card {
    padding: 2rem 1.25rem;
    border-radius: 0;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .payment-page .payment-status-card h2 {
    font-size: 1.4rem;
  }

  .payment-page .payment-status-card p {
    font-size: 0.95rem;
  }

  /* ── Loading card: reduce giant padding ── */
  .payment-page .payment-loading {
    padding: 2rem 1.25rem;
    border-radius: 0;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  /* ── Success overlay: reduce padding ── */
  .payment-page .payment-success-overlay {
    padding: 1.5rem 1.25rem;
    border-radius: 0;
    min-height: 100vh;
    min-height: 100dvh;
  }

  .payment-page .payment-success-overlay h2 {
    font-size: 1.5rem;
  }

  .payment-page .success-amount {
    font-size: 1.25rem;
  }

  /* ── Pay remaining / supported-token button ── */
  .payment-page .pay-remaining-btn {
    min-height: 52px;
    font-size: 1rem;
  }

  /* ── Copy tx hash button ── */
  .payment-page .copy-tx-btn {
    min-height: 44px;
    padding: 0.5rem 0.875rem;
  }

  /* ── Transaction hash: break long hashes ── */
  .payment-page .tx-hash {
    word-break: break-all;
    font-size: 0.75rem;
  }

  /* ── Session timer banner ── */
  .payment-page .session-timer-banner {
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
  }

  .payment-page .timer-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }

  .payment-page .timer-value {
    font-size: 1.1rem;
  }

  .payment-page .timer-label {
    font-size: 0.7rem;
  }

  .payment-page .timer-message {
    font-size: 0.7rem;
  }

  /* ── Unsupported-token warning: no horizontal overflow ── */
  .payment-page .unsupported-token-warning {
    text-align: left;
    word-break: break-word;
  }

  /* ── Footer: slightly tighter ── */
  .payment-page .payment-footer {
    margin-top: 0.5rem;
  }

  /* ── Verify message ── */
  .payment-page .verify-message {
    font-size: 0.85rem;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/PaymentPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF,gFAAgF;AAChF;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;EACnD;IACE,UAAU;IACV,sCAAsC;IACtC,0CAA0C;IAC1C,gDAAgD;IAChD,4CAA4C;IAC5C,8CAA8C;IAC9C,uBAAuB;IACvB,yDAAyD;IACzD,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,qDAAqD;EACrD;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,wDAAwD;EACxD;IACE,sCAAsC;EACxC;;EAEA,4DAA4D;EAC5D;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA,iFAAiF;EACjF;IACE,gBAAgB;IAChB,eAAe;IACf,0CAA0C;EAC5C;;EAEA,oDAAoD;EACpD;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,qDAAqD;EACrD;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,iDAAiD;EACjD;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,mDAAmD;EACnD;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,0CAA0C;EAC1C;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,iDAAiD;EACjD;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA,8CAA8C;EAC9C;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,4DAA4D;EAC5D;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * PaymentPage.css — Responsive overrides for src/pages/PaymentPage.jsx\n * Loads AFTER index.css. Uses .payment-page prefix (one extra class) to win\n * over the inline <style> block that React injects after the webpack bundle.\n *\n * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px\n *\n * This is a PUBLIC checkout page — no sidebar, no nav. The single-column\n * card layout is already correct for desktop. These overrides make it\n * app-like on phones: full-bleed card, bigger QR, 44px touch targets.\n */\n\n/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */\n@media (max-width: 991px) {\n  .payment-page {\n    padding: 0.75rem;\n  }\n\n  .payment-page .payment-container {\n    max-width: 520px;\n  }\n}\n\n/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  /* ── Full-bleed page: no gap on small screens ── */\n  .payment-page {\n    padding: 0;\n    /* Respect notched-device safe areas */\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    padding-left: env(safe-area-inset-left, 0px);\n    padding-right: env(safe-area-inset-right, 0px);\n    align-items: flex-start;\n    /* Prevent horizontal overflow from any overflow source */\n    overflow-x: hidden;\n  }\n\n  /* ── Container: full-width, full-height ── */\n  .payment-page .payment-container {\n    max-width: 100%;\n    max-height: none;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n\n  /* ── Card: fills the screen, no floating chrome ── */\n  .payment-page .payment-card {\n    border-radius: 0;\n    box-shadow: none;\n    min-height: 100vh;\n    min-height: 100dvh;\n    padding: 0;\n    max-height: none;\n    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);\n    border-radius: 24px;\n  }\n\n  .payment-page .payment-card.expanded {\n    padding: 0;\n    max-height: none;\n  }\n\n  /* ── Header: tighten logo area ── */\n  .payment-page .payment-header {\n    margin-bottom: 0.625rem;\n  }\n\n  .payment-page .payment-logo img {\n    max-width: 140px;\n  }\n\n  /* ── Amount: scale down slightly on narrow screens ── */\n  .payment-page .payment-amount {\n    font-size: clamp(1.75rem, 8vw, 2.5rem);\n  }\n\n  /* ── Partial payment banner: stack the progress values ── */\n  .payment-page .partial-progress {\n    flex-direction: column;\n    gap: 0.125rem;\n  }\n\n  /* ── Form selects: full-height tap target; font-size 1rem prevents iOS zoom ── */\n  .payment-page .form-group select {\n    min-height: 44px;\n    font-size: 1rem;\n    padding: 0.625rem 2.5rem 0.625rem 0.875rem;\n  }\n\n  /* ── Primary pay button: full-width, 52px tall ── */\n  .payment-page .pay-now-btn {\n    min-height: 52px;\n    font-size: 1.05rem;\n    border-radius: 12px;\n  }\n\n  /* ── Session info: wrap instead of side-by-side ── */\n  .payment-page .selected-info {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    justify-content: flex-start;\n  }\n\n  .payment-page .info-item {\n    font-size: 0.875rem;\n  }\n\n  /* ── Tabs: 44px touch targets ── */\n  .payment-page .tab-btn {\n    min-height: 44px;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  /* ── QR code: larger for legibility on phones ── */\n  .payment-page .qr-code-box {\n    width: 200px;\n    height: 200px;\n  }\n\n  /* ── Address box: wrap text on tiny screens ── */\n  .payment-page .address-text {\n    font-size: 0.625rem;\n    word-break: break-all;\n  }\n\n  /* ── Copy button: 44px tap target ── */\n  .payment-page .copy-btn {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  /* ── Wallet tab ── */\n  .payment-page .connect-wallet-btn {\n    min-height: 52px;\n    font-size: 1rem;\n  }\n\n  /* ── Change-selection: 44px touch target ── */\n  .payment-page .change-btn {\n    min-height: 44px;\n    font-size: 0.9rem;\n    margin-top: 0.625rem;\n  }\n\n  /* ── Status/error cards: reduce giant padding ── */\n  .payment-page .payment-status-card {\n    padding: 2rem 1.25rem;\n    border-radius: 0;\n    min-height: 100vh;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .payment-page .payment-status-card h2 {\n    font-size: 1.4rem;\n  }\n\n  .payment-page .payment-status-card p {\n    font-size: 0.95rem;\n  }\n\n  /* ── Loading card: reduce giant padding ── */\n  .payment-page .payment-loading {\n    padding: 2rem 1.25rem;\n    border-radius: 0;\n    min-height: 100vh;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ── Success overlay: reduce padding ── */\n  .payment-page .payment-success-overlay {\n    padding: 1.5rem 1.25rem;\n    border-radius: 0;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n\n  .payment-page .payment-success-overlay h2 {\n    font-size: 1.5rem;\n  }\n\n  .payment-page .success-amount {\n    font-size: 1.25rem;\n  }\n\n  /* ── Pay remaining / supported-token button ── */\n  .payment-page .pay-remaining-btn {\n    min-height: 52px;\n    font-size: 1rem;\n  }\n\n  /* ── Copy tx hash button ── */\n  .payment-page .copy-tx-btn {\n    min-height: 44px;\n    padding: 0.5rem 0.875rem;\n  }\n\n  /* ── Transaction hash: break long hashes ── */\n  .payment-page .tx-hash {\n    word-break: break-all;\n    font-size: 0.75rem;\n  }\n\n  /* ── Session timer banner ── */\n  .payment-page .session-timer-banner {\n    gap: 0.5rem;\n    padding: 0.5rem 0.75rem;\n  }\n\n  .payment-page .timer-icon {\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n  }\n\n  .payment-page .timer-value {\n    font-size: 1.1rem;\n  }\n\n  .payment-page .timer-label {\n    font-size: 0.7rem;\n  }\n\n  .payment-page .timer-message {\n    font-size: 0.7rem;\n  }\n\n  /* ── Unsupported-token warning: no horizontal overflow ── */\n  .payment-page .unsupported-token-warning {\n    text-align: left;\n    word-break: break-word;\n  }\n\n  /* ── Footer: slightly tighter ── */\n  .payment-page .payment-footer {\n    margin-top: 0.5rem;\n  }\n\n  /* ── Verify message ── */\n  .payment-page .verify-message {\n    font-size: 0.85rem;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
